const config = {
  API_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001',
  AUTH_SESSION_KEY: import.meta.env.VITE_JWT_STORAGE_KEY || 'accessToken',
  REFRESH_TOKEN_KEY: import.meta.env.VITE_REFRESH_TOKEN_KEY || 'refreshToken',
  MIDTRANS_CLIENT_KEY: import.meta.env.VITE_MIDTRANS_CLIENT_KEY || 'SB-Mid-client-YOUR-CLIENT-KEY',
};

export default config;
